import { useState } from 'react';

export const SECURITY_QUESTIONS = [
  "What is your mother's maiden name?",
  "What was the name of your first pet?",
  "What city were you born in?",
  "What is your favorite movie?",
  "What street did you grow up on?",
  "What was your childhood nickname?",
  "What is the name of your favorite teacher?",
  "What was the make of your first car?"
];

const CUSTOM = '__custom__';

const QuestionRow = ({ num, question, answer, onChange, answerPlaceholder }) => {
  const isPreset = !question || SECURITY_QUESTIONS.includes(question);
  const [custom, setCustom] = useState(!isPreset);

  const handleSelect = (e) => {
    if (e.target.value === CUSTOM) {
      setCustom(true);
      onChange(`security_q${num}`, '');
    } else {
      setCustom(false);
      onChange(`security_q${num}`, e.target.value);
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }} data-testid={`security-question-row-${num}`}>
      <div className="form-group" style={{ marginBottom: '0.25rem' }}>
        <label>Question {num}</label>
        <select value={custom ? CUSTOM : question} onChange={handleSelect} data-testid={`security-q${num}-select`}>
          <option value="">Select a question...</option>
          {SECURITY_QUESTIONS.map((q) => <option key={q} value={q}>{q}</option>)}
          <option value={CUSTOM}>Write my own question…</option>
        </select>
      </div>
      {custom && (
        <div className="form-group" style={{ marginBottom: '0.25rem' }}>
          <input
            value={question}
            onChange={(e) => onChange(`security_q${num}`, e.target.value)}
            placeholder="Type your own question, e.g. What was my grandmother's garden flower?"
            maxLength={150}
            data-testid={`security-q${num}-custom-input`}
          />
        </div>
      )}
      {question && (
        <div className="form-group" style={{ marginBottom: 0 }}>
          <input
            value={answer}
            onChange={(e) => onChange(`security_a${num}`, e.target.value)}
            placeholder={answerPlaceholder}
            data-testid={`security-a${num}-input`}
          />
        </div>
      )}
    </div>
  );
};

const SecurityQuestionsEditor = ({ values, onChange, answerPlaceholder = 'Your answer' }) => (
  <>
    {[1, 2, 3].map((num) => (
      <QuestionRow
        key={num}
        num={num}
        question={values[`security_q${num}`] || ''}
        answer={values[`security_a${num}`] || ''}
        onChange={onChange}
        answerPlaceholder={answerPlaceholder}
      />
    ))}
  </>
);

export default SecurityQuestionsEditor;
